import React, { useState } from 'react'

import './Header.css'
import CIconButton from '../UI/CIconButton'
import { useSelector } from 'react-redux'

const Header = () => {
  const {  user } = useSelector((state) => state.auth)

    return (
        <div className='header'>
            <span className='text-4'>Welcome back, {user?.firstnames}!</span>
        </div>
    )
}

export default Header
